import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchAnnotatedTexts} from '../../home/actions';
import {FormattedMessage} from 'react-intl';
import Link from '../../routing/components/Link';
import {structureIndexRoute} from '../../../constants/public-routes';
import Table from '../../ui/components/Table';
import RSSfeed from '../../home/components/RSSfeed';
import {apiRoutes} from '../../../api/api';

class LawsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    this.props.fetchAnnotatedTexts(this.props.language);
  }

  render() {
    let items = [];
    this.props.texts.forEach((item, i) => {
      // TODO should be in selector
      items.push([(<Link key={i} url={item.url}>{item.label || <FormattedMessage id="noStructureLabel"/>}</Link>)]);
    });

    return (
      <div>
        <h1><FormattedMessage key={0} id={'annotatedTexts'}/></h1>
        <Table items={items}/>
        {/*
        RSS-feeds are temporarely commented out.
        <div className="home-page-rss-feed">
          <FormattedMessage id="stay-informed-latest"/>:&nbsp;
          <RSSfeed feedURI={apiRoutes.feeds.latest()}/>
        </div>
        */}

      </div>
    );
  }
}

LawsContainer.propTypes = {
  fetchAnnotatedTexts: PropTypes.func.isRequired,
  texts: PropTypes.array.isRequired,
  language: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  const {annotatedTexts, intl} = state;
  // TODO selector to give label
  let items = annotatedTexts.items ? annotatedTexts.items.sort(
    (a, b) => {
      return a.attributes.order < b.attributes.order ? -1 : 1;
    }
  ) : [];
  let texts = items.map(item => {
    return {
      url: structureIndexRoute(intl.locale, item.id),
      id: item.id,
      label: item.attributes.label
    };
  });
  return {
    texts,
    language: intl.locale
  };
}

function mapDispatchToProps(dispatch) {
  return {fetchAnnotatedTexts: bindActionCreators(fetchAnnotatedTexts, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(LawsContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/laws/containers/LawsContainer.js
 **/